(function () {
  'use strict';

  document.addEventListener('submit', async function (event) {
    // Only intercept product add-to-cart forms
    if (!event.target.closest('product-form')) return;

    var form = event.target;

    // Re-triggered after our check — let ProductForm handle it
    if (form._subGuardPass) return;

    var fd = new FormData(form);
    var sellingPlan = fd.get('selling_plan');

    // Not a subscription product — don't interfere
    if (!sellingPlan) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var variantId = parseInt(fd.get('id'), 10);
    var planId    = parseInt(sellingPlan, 10);

    try {
      var cart = await fetch(Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); });

      var existingSubs = cart.items.filter(function (item) {
        return !!item.selling_plan_allocation;
      });

      // Same product + same plan already in cart — just open the drawer, nothing to add
      var alreadyInCart = existingSubs.some(function (item) {
        return (
          item.variant_id === variantId &&
          item.selling_plan_allocation.selling_plan.id === planId
        );
      });

      // Already in cart with same plan — go straight to checkout
      if (alreadyInCart) {
        window.location.href = Shopify.routes.root + 'checkout';
        return;
      }

      // Different subscription(s) in cart — remove them first
      if (existingSubs.length > 0) {
        var updates = {};
        existingSubs.forEach(function (item) { updates[item.key] = 0; });
        await fetch(Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ updates: updates })
        });
      }
    } catch (_) {
      // Network error — let the normal submit proceed anyway
    }

    // Add to cart ourselves then redirect to checkout
    try {
      var addData = new FormData();
      addData.append('id', fd.get('id'));
      addData.append('quantity', fd.get('quantity') || 1);
      addData.append('selling_plan', sellingPlan);

      var res = await fetch(Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: addData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (res.ok) {
        window.location.href = Shopify.routes.root + 'checkout';
        return;
      }
    } catch (_) {}

    // Fallback : hand back to ProductForm if the add failed
    form._subGuardPass = true;
    try {
      form.requestSubmit();
    } catch (_) {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
    setTimeout(function () { delete form._subGuardPass; }, 0);

  }, { capture: true });
})();
